export default __webpack_public_path__ + "static/blueprint-0a8595647cfdb2eb7c006730704cc7a0.png";